import { render, staticRenderFns } from "./HeaderView.vue?vue&type=template&id=a875c04c&scoped=true&"
import script from "./HeaderView.vue?vue&type=script&lang=js&"
export * from "./HeaderView.vue?vue&type=script&lang=js&"
import style0 from "./HeaderView.vue?vue&type=style&index=0&id=a875c04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a875c04c",
  null
  
)

component.options.__file = "HeaderView.vue"
export default component.exports